__cw__define(['jquery'], function ($) {
  'use strict';

  $(document).ready(function () {
    function createTooltip(button) {
      var content = $(button).data('content');
      var position = $(button).data('position');
      var tooltip = $('<div class="ia-tooltip ' + position + '"></div>').html(content).appendTo('body');
      $(button).data('tooltip', tooltip);
      positionTooltip(button, tooltip, position);
    }
    function positionTooltip(button, tooltip, position) {
      var offset = $(button).offset();
      var buttonHeight = $(button).outerHeight();
      var buttonWidth = $(button).outerWidth();
      var tooltipHeight = tooltip.outerHeight();
      var tooltipWidth = tooltip.outerWidth();
      switch (position) {
        case 'top':
          tooltip.css({
            top: offset.top - (tooltipHeight + 8),
            left: offset.left + buttonWidth / 2 - tooltipWidth / 2
          });
          break;
        case 'right':
          tooltip.css({
            top: offset.top + buttonHeight / 2 - tooltipHeight / 2,
            left: offset.left + (buttonWidth + 8)
          });
          break;
        case 'bottom':
          tooltip.css({
            top: offset.top + (buttonHeight + 14),
            left: offset.left + buttonWidth / 2 - tooltipWidth / 2
          });
          break;
        case 'left':
          tooltip.css({
            top: offset.top + buttonHeight / 2 - tooltipHeight / 2,
            left: offset.left - (tooltipWidth + 14)
          });
          break;
      }

      // Ensure the tooltip stays within the body
      var bodyWidth = $('body').outerWidth();
      var bodyHeight = $('body').outerHeight();
      if (tooltip.offset().left < 0) {
        tooltip.css('left', 0);
      } else if (tooltip.offset().left + tooltipWidth > bodyWidth) {
        tooltip.css('left', bodyWidth - tooltipWidth);
      }
      if (tooltip.offset().top < 0) {
        tooltip.css('top', 0);
      } else if (tooltip.offset().top + tooltipHeight > bodyHeight) {
        tooltip.css('top', bodyHeight - tooltipHeight);
      }
    }

    // Update the selector below with the correct selector for your buttons
    $(document).on('click', '.ia-tooltip-button', function (e) {
      var _this = this;
      e.stopPropagation();
      var tooltip = $(this).data('tooltip');
      if (tooltip && tooltip.is(':visible')) {
        tooltip.hide();
      } else {
        if (!tooltip) {
          createTooltip(this);
        }

        // Adding a small delay to ensure the tooltip is visible
        setTimeout(function () {
          $(_this).data('tooltip').show();
        }, 0);
      }
    });
    $(document).on('click', function () {
      $('.ia-tooltip').hide();
    });
    $(document).on('click', '.ia-tooltip', function (e) {
      e.stopPropagation();
    });
  });
});